import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';


@Component({
  selector: 'app-arkiguest',
  templateUrl: './arkiguest.component.html',
  styleUrls: ['./arkiguest.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class ArkiguestComponent implements OnInit {
  agscadenti:any=[];

  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/arkiguestaperti',params).subscribe(dataag => {
        this.agscadenti=dataag.Result;
      });
    });
  }

  goto(){

    this.router.navigateByUrl('/java/arkiguest/login/LogonServletAG?oper=1'.replace('?','QUESTION').replace('=','UGUAL'));
    
  }
  apri(segn){
    let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:2,
        timbro:segn.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('arkiguest/login/LogonServletAG','POST',params);
  }

}
